<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col md="3">
          <v-row>
            <v-col>
              <v-card shrink height="75vh">
                <v-toolbar flat color="grey lighten-3">
                  <v-toolbar-title>{{ $t('usersGroups.label.usersGroups') }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom open-delay="600">
                    <template v-slot:activator="{ on }">
                      <v-btn
                          id="btn_new_group"
                          v-on="on"
                          icon
                          @click="newGroup()"
                          color="primary"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('usersGroups.label.createGroup') }}</span>
                  </v-tooltip>
                </v-toolbar>
                <v-list max-height="65vh" style="overflow-y: auto">
                  <v-list-item-group v-model="selectedGroupIndex" color="primary">
                    <v-list-item
                        v-for="(group, i) in groups"
                        :key="i"
                        @mouseenter="overGroupName = group.name"
                        @mouseleave="overGroupName = null"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="group.label"></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-tooltip bottom open-delay="600">
                          <template v-slot:activator="{ on }">
                            <v-btn
                                id="btn_delete_group"
                                v-on="on"
                                icon
                                @click.stop="maybeDeleteGroup(group)"
                                color="primary"
                                :style="overGroupName === group.name ? '' : 'visibility: hidden'"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('usersGroups.label.deleteGroup') }}</span>
                        </v-tooltip>
                      </v-list-item-action>
<!--                      <v-list-item-icon :style="overGroupName === group.name ? '' : 'visibility: hidden'">-->
<!--                        <v-icon>mdi-delete</v-icon>-->
<!--                      </v-list-item-icon>-->
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="selectedGroup || createGroup">
          <v-row>
            <v-col>
              <v-card shrink height="33vh">
                <v-toolbar flat color="grey lighten-3">
                  <v-toolbar-title>
                    {{ createGroup ? $t('usersGroups.label.newGroup') : $t('usersGroups.label.group', {group: selectedGroup.label}) }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip v-if="!editionMode" bottom open-delay="600">
                    <template v-slot:activator="{ on }">
                      <v-btn
                          id="btn_edit_group"
                          v-on="on"
                          icon
                          @click="editGroup()"
                          color="primary"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('usersGroups.label.edit') }}</span>
                  </v-tooltip>
                  <div v-if="editionMode">
                    <v-btn
                        id="btn_cancel_group"
                        text
                        @click="cancelEdition()"
                    >
                      {{ $t('app.button.cancel') }}
                    </v-btn>
                    <v-btn
                        id="btn_save_group"
                        color="primary"
                        @click="saveGroup()"
                        :disabled="!validGroupData"
                    >
                      {{ $t('app.button.save') }}
                    </v-btn>
                  </div>
                </v-toolbar>
                <v-form ref="form" v-model="validGroupData">
                  <v-container>
                    <v-row>
                      <v-col id="group_label" md="4">
                        <v-text-field
                            v-model="groupLabel"
                            :rules="labelRules"
                            :label="$t('app.label.name')"
                            :readonly="!editionMode"
                            :class="editionMode ? '' : 'removeBorder'"
                        ></v-text-field>
                      </v-col>
                      <v-col id="group_max_users" md="4">
                        <v-text-field
                            v-model="groupMaxUsers"
                            :rules="maxUsersRules"
                            :label="$t('usersGroups.label.maxUsers')"
                            :readonly="!editionMode"
                            :class="editionMode ? '' : 'removeBorder'"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="!createGroup">
                      <v-col id="group_createdBy" md="4">
                        <v-text-field
                            v-model="selectedGroup.createdBy"
                            :label="$t('app.label.createdBy')"
                            readonly
                            :disabled="editionMode"
                            class="removeBorder"
                        ></v-text-field>
                      </v-col>
                      <v-col id="group_createdAt" md="4">
                        <v-text-field
                            v-model="humanCreatedAt"
                            :label="$t('app.label.createdDate')"
                            readonly
                            :disabled="editionMode"
                            class="removeBorder"
                        ></v-text-field>
                      </v-col>
<!--                      <v-col id="group_createdBy">{{ $t('app.label.createdBy') + $t('colon') + selectedGroup.createdBy }}</v-col>-->
<!--                      <v-col id="group_createdAt">{{ $t('app.label.createdDate') + $t('colon') + moment(selectedGroup.createdAt).fromNow() }}</v-col>-->
                    </v-row>
                  </v-container>
                </v-form>
              </v-card>
            </v-col>
            <v-col v-if="!createGroup">
              <v-card shrink height="33vh">
                <v-toolbar flat color="grey lighten-3">
                  <v-toolbar-title>
                    {{ $t('usersGroups.label.usersOfGroup', {group: selectedGroup.label}) }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip v-if="!editionMode" bottom open-delay="600">
                    <template v-slot:activator="{ on }">
                      <v-btn
                          id="btn_manage_group_users"
                          color="primary"
                          icon
                          @click="showGroupInUsersTab()"
                          v-on="on"
                      >
                        <v-icon>mdi-open-in-new</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('usersGroups.label.manageUsers') }}</span>
                  </v-tooltip>
                </v-toolbar>
                <v-list max-height="25vh" style="overflow-y: auto">
                  <v-list-item-group v-model="selectedUserIndex" color="primary">
                    <v-list-item v-for="(user, i) in users" :key="i">
                      <v-list-item-content @click="showUserInUsersTab(user.username)">
                        <v-list-item-title v-text="user.username"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="!createGroup">
            <v-col>
              <v-card shrink height="40vh">
                <v-toolbar flat color="grey lighten-3">
                  <v-toolbar-title>
                    {{ $t('usersGroups.label.attachedRolesOf', {group: selectedGroup.label}) }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip v-if="!rolesEditMode" bottom open-delay="600">
                    <template v-slot:activator="{ on }">
                      <v-btn
                          id="btn_edit_roles"
                          v-on="on"
                          icon
                          @click="editRoles()"
                          color="primary"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('users.label.edit') }}</span>
                  </v-tooltip>
                  <div v-if="rolesEditMode">
                    <v-btn
                        id="btn_cancel_roles"
                        text
                        @click="cancelRoles()"
                    >
                      {{ $t('app.button.cancel') }}
                    </v-btn>
                    <v-btn
                        id="btn_save_roles"
                        color="primary"
                        @click="saveRoles()"
                        :disabled="!validGroupData"
                    >
                      {{ $t('app.button.save') }}
                    </v-btn>
                  </div>
                </v-toolbar>
                <RoleSelector
                    ref="RoleSelector"
                    v-if="selectedGroup"
                    :target="selectedGroup"
                    :rolesEditMode="rolesEditMode"
                    :roleSelector="roleSelector"
                ></RoleSelector>
              </v-card>
            </v-col>
            <v-col>
              <v-card shrink height="40vh">
                <v-toolbar flat color="grey lighten-3">
                  <v-toolbar-title>
                    {{ $t('usersGroups.label.projectsOfGroup', {group: selectedGroup.label}) }}
                  </v-toolbar-title>
                </v-toolbar>
                <v-list max-height="30vh" style="overflow-y: auto">
                  <v-list-item-group v-model="selectedProjectIndex" color="primary">
                    <v-list-item v-for="(project, i) in projects" :key="i">
                      <v-list-item-content>
                        <v-list-item-title v-text="project.label"></v-list-item-title>
                        <v-list-item-subtitle>{{ $t('app.label.createdBy') + " " + project.createdBy }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <DeleteConfirmDialog
        v-if="confirmDeleteGroup"
        idHint="usersGroup"
        :title="$t('usersGroups.label.confirmDeleteTitle')"
        :html="deletedGroup != null ? $t('usersGroups.label.confirmDeleteMessage', {group: this.deletedGroup.label}) : ''"
        @yes="doDeleteGroup()"
        @no="dontDeleteGroup()"
    ></DeleteConfirmDialog>
  </div>
</template>

<script>
import RoleSelector from "./RoleSelector";
import DeleteConfirmDialog from "../utils/DeleteConfirmDialog";
import {
  openGroupAdmin,
  openGroupAdminAndSelectGroup,
  openUserAdminAndSelectGroup,
  openUserAdminAndSelectGroupAndUser
} from "@/routes/userAdminRoutes";
import {mapState, mapMutations, mapActions} from "vuex";
import {mapProperty} from "@/utils/vuexx";
import moment from "moment";
import {decodeParams} from "@/routes/pathParams";

export default {
  components: {
    RoleSelector,
    DeleteConfirmDialog,
  },
  data() {
    return {
      rolesEditMode: false,
      destroying: false,
      deletedGroup: null,
      confirmDeleteGroup: false,
      editMode: false,
      createGroup: false,
      selectedGroupIndex: null,
      selectedUserIndex: null,
      selectedProjectIndex: null,
      overGroupName: null,
      newGroupLabel: null,
      newGroupMaxUsers: null,
      editionMode: false,
      validGroupData: true,
      labelRules: [
        v => !!v || this.$i18n.t("usersGroups.label.nonEmptyGroupName"),
        v =>
            (v && v.length <= 40) ||
            this.$i18n.t("createProject.errors.nameLength", {count: 40})
      ],
      maxUsersRules: [
        v => !!v || this.$i18n.t("app.message.required"),
        v =>
            /^(0|-?[1-9]\d*)$/.test(v) ||
            this.$i18n.t("usersGroups.label.mustBeInteger")
      ],
    }
  },
  mounted() {
    this.selectedUserIndex = null
    const self = this
    const mount = async function () {
      if (self.loggedUser) {
        self.setLoggedUser(self.loggedUser)
      }
      await self.getRoles()
      await self.getGroups()
      self.selectGroupByParams(self.$route.params.selectionParams)
    }
    mount()
  },
  watch: {
    '$route.params.selectionParams': function (value) {
      this.selectGroupByParams(value)
    },
    selectedGroupIndex: function (value) {
      if (value != null) {
        const selectedGroup = this.groups[value]
        openGroupAdminAndSelectGroup(selectedGroup.name)
      } else {
        openGroupAdmin(null)
      }
    },
    group: function (value) {
      if (!value)
        this.selectedGroupIndex = null
      else
        this.cancelEdition()
    },
    loggedUser: function (value) {
      // workaround to app init mess: auth/user store value is set after this component's mount
      this.setLoggedUser(value)
    }
  },
  computed: {
    ...mapState("auth", {loggedUser: "user"}),
    ...mapState("usersGroups", ["groups", "group", "users", "projects", "roleSelector"]),
    selectedGroup: mapProperty("usersGroups", "group"),
    humanCreatedAt() {
      moment.locale(this.$i18n.locale);
      return this.selectedGroup ? moment(this.selectedGroup.createdAt).fromNow() : ""
    },
    groupLabel: {
      get() {
        return this.selectedGroup ? (this.editionMode ? this.newGroupLabel : this.selectedGroup.label) : ""
      },
      set(value) {
        this.newGroupLabel = value
      }
    },
    groupMaxUsers: {
      get() {
        return this.selectedGroup ? (this.editionMode ? this.newGroupMaxUsers : this.selectedGroup.maxUsers) : ""
      },
      set(value) {
        this.newGroupMaxUsers = value
      }
    },
  },
  methods: {
    ...mapMutations("usersGroups", ["setGroup", "setLoggedUser"]),
    ...mapActions("usersGroups", ["getGroups", "getGroup", "getGroupUsers", "getGroupProjects", "updateGroup", "addGroup", "deleteGroup", "getRoles"]),
    selectGroupByParams(params) {
      // this is required because of the UserAdmin tabs (sharing the same route)
      if (!this.$route.path.startsWith("/admin/groups"))
        return
      if (params) {
        const selectionParams = decodeParams(params)
        if (selectionParams.groupName) {
          this.selectGroup(selectionParams.groupName)
        } else {
          this.selectGroup(null)
        }
      } else {
        this.selectGroup(null)
      }
    },
    async selectGroup(groupName) {
      if (groupName != null) {
        const group = await this.getGroup(groupName)
        // get group users and projects (don't await)
        this.getGroupUsers(groupName)
        this.getGroupProjects(groupName)
        this.newGroupLabel = group.label
        this.newGroupMaxUsers = group.maxUsers
        const index = this.groups.findIndex(group => group.name === groupName)
        // also select the user in the list 
        // but don't do it (to prevent watch loop?) if it is already the case
        if (index !== -1 && this.selectedGroupIndex !== index)
          this.selectedGroupIndex = index
      } else {
        this.selectedGroup = null
        this.newGroupLabel = null
        this.newGroupMaxUsers = null
        // also unselect the user in the list 
        // but don't do it (to prevent watch loop?) if it is already the case
        if (this.selectedGroupIndex != null)
          this.selectedGroupIndex = null
      }
    },
    showGroupInUsersTab() {
      if (this.group)
        openUserAdminAndSelectGroup(this.group.name)
    },
    showUserInUsersTab(username) {
      if (this.group && username)
        openUserAdminAndSelectGroupAndUser(this.group.name, username)
    },
    newGroup() {
      this.createGroup = true
      this.editionMode = true
      this.newGroupLabel = ""
      this.newGroupMaxUsers = "5"
    },
    maybeDeleteGroup(group) {
      this.deletedGroup = group
      this.confirmDeleteGroup = true
    },
    dontDeleteGroup() {
      this.deletedGroup = null
      this.confirmDeleteGroup = false
    },
    doDeleteGroup() {
      try {
        this.deleteGroup(this.deletedGroup.name)
      } finally {
        this.confirmDeleteGroup = false
      }
    },
    editGroup() {
      this.editionMode = true
    },
    cancelEdition() {
      this.editionMode = false
      this.createGroup = false
      this.newGroupLabel = this.selectedGroup ? this.selectedGroup.label : ""
      this.newGroupMaxUsers = this.selectedGroup.maxUsers
    },
    async saveGroup() {
      let newGroupName;
      let success = false
      try {
        if (this.createGroup) {
          const group = await this.addGroup({label: this.newGroupLabel, maxUsers: parseInt(this.newGroupMaxUsers)})
          newGroupName = group.name
        } else {
          const update = {}
          const newMaxUsers = parseInt(this.newGroupMaxUsers)
          if (this.newGroupLabel !== this.group.label)
            update.label = this.newGroupLabel
          if (newMaxUsers !== this.group.maxUsers)
            update.maxUsers = newMaxUsers
          if (Object.keys(update).length !== 0)
            await this.updateGroup({groupName: this.selectedGroup.name, update})
        }
        success = true
      } finally {
        try {
          if (success) {
            if (this.createGroup) {
              await this.getGroups();
              await this.getGroup(newGroupName)
              const index = this.groups.findIndex(group => group.name === newGroupName)
              if (index !== -1)
                this.selectedGroupIndex = index
            } else {
              await this.getGroup(this.selectedGroup.name)
            }
          }
        } finally {
          this.cancelEdition()
        }
      }
    },
    editRoles() {
      this.rolesEditMode = true
    },
    cancelRoles() {
      if (this.rolesEditMode) {
        this.rolesEditMode = false
        //this.initRoleDataFromStore()
      }
    },
    async saveRoles() {
      const selectedSystemRoles = [...this.$refs["RoleSelector"].selectedSystemRoles]
      const selectedFunctionalRoles = [...this.$refs["RoleSelector"].selectedFunctionalRoles]
      this.rolesEditMode = false
      const attachedRoles = []
      for (const i of selectedSystemRoles)
        attachedRoles.push(this.roleSelector.groupSystemRoles[i].rolename)
      for (const i of selectedFunctionalRoles)
        attachedRoles.push(this.roleSelector.groupFunctionalRoles[i].rolename)
      // save new roles
      await this.updateGroup({groupName: this.selectedGroup.name, update: {attachedRoles}})
      // get new roles from api (to be sure)
      await this.getGroup(this.selectedGroup.name)
      // init roles panel (don't await for result)
      //this.initRoleDataFromStore()

    },
  }
}
</script>

<style>
.removeBorder > .v-input__control > .v-input__slot::after {
  border-style: none !important;
}

.removeBorder > .v-input__control > .v-input__slot::before {
  border-style: none !important;
}
</style>